import TopBar from './components/TopBar';
import LeftMetrics from './components/LeftMetrics';
import LiveActivityStream from './components/LiveActivityStream';
import LeafletWorldMap from './components/LeafletWorldMap';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white overflow-hidden relative">
      {/* Top Bar */}
      <TopBar />

      {/* Main Content Area */}
      <main className="relative h-[calc(100vh-80px)]">
        {/* Real World Map Background with Leaflet - with left padding for integrated rail */}
        <div className="absolute inset-0 pl-96">
          <LeafletWorldMap />
        </div>

        {/* Left Metrics - Integrated Information Rail */}
        <LeftMetrics />

        {/* Live Activity Stream - Bottom Right */}
        <LiveActivityStream />
      </main>

      {/* Footer Status Bar */}
      <footer className="fixed bottom-0 left-0 right-0 h-8 bg-slate-950/80 backdrop-blur-sm border-t border-slate-800/50 flex items-center justify-between px-6 text-[10px] text-slate-400" style={{ zIndex: 50 }}>
        <div className="flex items-center gap-4">
          <span className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-emerald-400"></i>
            System Status: Operational
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-server-line text-cyan-400"></i>
            All Regions Online
          </span>
        </div>
        <div>
          Jumborca Infrastructure Monitor v2.1.0
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
